import React from "react";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "../lib/whatsapp";
import { resolveImage } from "../lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const msg = `Olá Avantech! Tenho interesse no produto: ${product.name}. Pode me passar mais informações?`;
  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group bg-white border border-[#E5E7EB] rounded-none flex flex-col hover:border-[#1A1A1A] transition-colors"
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#F9F9F9] border-b border-[#E5E7EB]">
        <img
          src={resolveImage(product.image)}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
        />
      </div>
      <div className="p-6 md:p-8 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-3">
          <span className="font-mono-sm text-[10px] tracking-[0.2em] uppercase text-[#E84E34]">
            {product.category}
          </span>
          {product.subcategory && (
            <span className="font-mono-sm text-[10px] tracking-[0.2em] uppercase text-[#6B7280]">
              / {product.subcategory}
            </span>
          )}
        </div>
        <h3 className="font-display text-xl md:text-2xl font-bold leading-tight">
          {product.name}
        </h3>
        <p className="mt-3 text-sm text-[#374151] leading-relaxed">{product.description}</p>

        {product.highlights?.length > 0 && (
          <ul className="mt-4 space-y-1.5 text-xs text-[#6B7280]">
            {product.highlights.slice(0, 4).map((h, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="text-[#E84E34] font-bold">+</span>
                {h}
              </li>
            ))}
          </ul>
        )}

        <a
          href={waLink(msg)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`product-cta-${product.id}`}
          className="mt-6 inline-flex items-center justify-between bg-[#1A1A1A] text-white px-5 py-3.5 text-xs font-bold uppercase tracking-[0.18em] hover:bg-[#E84E34] transition-colors"
        >
          {product.action}
          <ArrowUpRight size={16} />
        </a>
      </div>
    </article>
  );
};

export default ProductCard;
